import users from "@/router/admin/users";
import clientsControl from "@/router/admin/clientsControl";
import agentsControl from "@/router/admin/agentsControl";
import directories from "@/router/admin/directories";
import internationalization from "@/router/admin/internationalization";
import administration from "@/router/admin/administration";
import processes from "./processes";
import formBuilder from "@/router/admin/formBuilder";
import files from "@/router/admin/files"
export default {
    name: 'admin',
    path:'/admin',
    component: () => import('@/views/admin/index.vue'),
    children: [
        directories,
        users,
        clientsControl,
        agentsControl,
        internationalization,
        administration,
        processes,
        formBuilder,
        files
    ]
};
